export const PEDAGOGICAL = {
  1: {
    field: "Physique — Chaleur & état de la matière",
    title: "Comment la chaleur voyage",
    child_text: "Quand la forge chauffe, la chaleur monte en vapeur. Cette vapeur peut pousser des machines très loin — comme le premier train !",
    teen_text: "La conduction thermique et la vaporisation ont propulsé la révolution industrielle : la chaleur d'un foyer devient énergie mécanique via un fluide (eau/vapeur), puis énergie électrique.",
    fun_fact: "Le premier moteur à vapeur date de 1698 (Thomas Savery), soit près de 2000 ans après les jouets à vapeur d'Héron d'Alexandrie !",
  },
  2: {
    field: "Physique — Poids, levier & rotation",
    title: "La force du levier",
    child_text: "Une petite pierre bien posée peut faire tourner un très grand engrenage : c'est la magie du levier !",
    teen_text: "Un levier multiplie la force appliquée en jouant sur les bras. Archimède disait : « Donnez-moi un point d'appui et je soulèverai le monde. »",
    fun_fact: "Les moulins médiévaux à eau utilisaient jusqu'à 5 leviers imbriqués pour moudre la farine avec un débit constant.",
  },
  3: {
    field: "Physique — Ondes & réflexion",
    title: "Les ondes qui rebondissent",
    child_text: "Le son de la cloche voyage en cercles, comme quand tu jettes un caillou dans l'eau. Un miroir peut renvoyer une lumière très loin !",
    teen_text: "Les ondes sonores et lumineuses se réfléchissent selon la loi des angles (angle d'incidence = angle de réflexion). Les paraboles concentrent l'énergie en un point.",
    fun_fact: "Archimède aurait incendié des navires romains à distance en concentrant le soleil avec des miroirs paraboliques (bataille de Syracuse, 212 av. J.-C.).",
  },
  4: {
    field: "Physique — Résonance & convergence",
    title: "Quand tout s'aligne",
    child_text: "Trois lignes qui se rejoignent au même endroit créent quelque chose de très fort. C'est comme trois amis qui unissent leurs voix !",
    teen_text: "Une convergence est une superposition constructive : plusieurs ondes/énergies en phase s'additionnent. C'est le principe des lasers, des chambres d'écho, de la fusion nucléaire.",
    fun_fact: "Dans la Fusion, il faut réunir 3 conditions (température, pression, temps) simultanément — le fameux critère de Lawson (1955).",
  },
  5: {
    field: "Astronomie — Éclipse & mécanique céleste",
    title: "L'éclipse expliquée",
    child_text: "Une éclipse, c'est quand la Lune passe pile devant le Soleil et cache sa lumière. Il faut être au bon endroit au bon moment !",
    teen_text: "Une éclipse totale nécessite l'alignement précis de trois corps célestes — un phénomène de mécanique orbitale rare (~1 éclipse totale visible chaque 375 ans en un lieu donné).",
    fun_fact: "La Renaissance a marqué le passage du modèle géocentrique au modèle héliocentrique de Copernic (1543), révolutionnant la compréhension des éclipses.",
  },
};

export function getPedagogicalCard(levelId) {
  return PEDAGOGICAL[levelId] || null;
}
